import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import 'react-responsive-modal/styles.css';
import { useOutletContext } from 'react-router-dom';
import styled from 'styled-components';
import { OptionGroupType } from '../../controller/ProductController';
import { CurrentStoreContext } from '../../controller/StoreController';
import { useToast } from '../../controller/ToastController';
import '../../styles/CustomModal.css';
import { DropdownType } from '../../utils/DataType';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  optionList: OptionGroupType[];
  options: any[];
  setOptions: (options: OptionGroupType[]) => void;
};

const numList: any = [];
for (let i = 1; i < 11; i++) {
  numList.push({
    key: i,
    value: i,
    name: `${i}개`,
    label: `${i}개`,
  });
}

const AddOptionModal = ({ isVisible, setVisible, optionList, options, setOptions }: Props) => {
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const showToast = useToast();

  const [keyword, setKeyword] = useState<string>('');
  const [searchedList, setSearchedList] = useState<OptionGroupType[]>([]);

  const [optionsTemp, setOptionsTemp] = useState<any[]>([]);

  const onCloseModal = () => {
    setKeyword('');
    setVisible(false);
  };

  // 필수 확인
  const checkRequired = () => {
    return true;
    return false;
  };

  const handleOptionTempClick = (item: OptionGroupType) => {
    if (optionsTemp.find((option: DropdownType) => option.value === item.option_type_id)) {
      setOptionsTemp([...optionsTemp.filter((option) => option.value !== item.option_type_id)]);
    } else {
      setOptionsTemp([
        ...optionsTemp,
        {
          value: item.option_type_id,
          name: item.name,
        },
      ]);
    }
  };

  const saveOptions = () => {
    setOptions([...optionsTemp]);
    setVisible(false);
    showToast('옵션을 추가했어요');
  };

  // 검색
  const getSearchResult = () => {
    setSearchedList(optionList.filter((item) => item.name.includes(keyword)));
  };

  useEffect(() => {
    setSearchedList([...optionList]);
  }, [optionList]);

  useEffect(() => {
    if (isVisible) {
      setOptionsTemp([...options]);
    }
  }, [isVisible]);

  return (
    <Modal
      isOpen={isVisible}
      onRequestClose={onCloseModal}
      className="addOptionModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}>
      <Style>
        <div className="modal">
          <img
            className="closeIcon"
            onClick={onCloseModal}
            src={`${process.env.PUBLIC_URL}/svg/ic_close.svg`}
            alt="close"
          />
          <div className="modal_content">
            <div className="modalTitle">
              <h4>옵션 선택하기</h4>
            </div>
            <div className="inputText">
              <div className="search">
                <input
                  type="text"
                  value={keyword}
                  placeholder="추가하실 옵션명을 검색해주세요"
                  autoFocus={false}
                  onChange={(e) => setKeyword(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      getSearchResult();
                    }
                  }}
                />
                <button className="searchBox" onClick={getSearchResult}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_search_grey.svg`} alt="search" />
                </button>
                <div className="searchedList">
                  {searchedList.map((item: OptionGroupType, index: number) => {
                    return (
                      <label className="searchedWrap" htmlFor={`check_${index}`}>
                        <div key={index} className="searchedItem">
                          <h4>
                            {item.name}
                            <span className={`${item.input_min > 0 && 'required'}`}>
                              {item.input_min > 0 ? '(필수)' : '(선택)'}
                            </span>
                          </h4>
                          {/* <label htmlFor={`check_${index}`}> */}
                          <input
                            id={`check_${index}`}
                            type="checkbox"
                            autoFocus={false}
                            checked={
                              optionsTemp.filter((option) => option.value === item.option_type_id)
                                .length > 0
                            }
                            onChange={() => handleOptionTempClick(item)}
                          />
                          {/* </label> */}
                        </div>
                        {item.option_list.map((option, optionIdx) => (
                          <div className="searchedItem optionItem" key={optionIdx}>
                            <h4>- {option.name}</h4>
                            <h4 className="price">{option.price.toLocaleString()}원</h4>
                          </div>
                        ))}
                      </label>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
          <div className="modal_footer">
            <button
              className={`submitButton ${!checkRequired() && 'inactive'}`}
              onClick={saveOptions}>
              저장
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default AddOptionModal;

const Style = styled.div`
  .modalTitle {
    text-align: center;
    margin-bottom: 30px;
    h4 {
      font-size: 20px;
      font-weight: 600;
      color: #555;
    }
  }
  .modal_content {
    padding: 8% 6% 0 6%;
  }
  .modal_footer {
    padding: 0 6% 6% 6%;
  }
  .inputText {
    img {
      cursor: pointer;
    }
  }

  span {
    margin-left: 4px;
    font-size: 12px;
    line-height: 20px;
    color: #327ad0;
  }
  span.required {
    color: #ff7e7e;
  }

  .search {
    width: 100%;
    position: relative;

    input {
      border-radius: 5px 5px 0 0;
      border: 1px solid #cecece;
      background: #f7f7f7;
      font-weight: 400;
      padding: 10px 24px;
    }
    .searchBox {
      top: 0;
      padding: 8px 0;
      position: absolute;
      display: flex;
      align-items: center;
      cursor: pointer;
      right: 14px;
    }
    .searchedList {
      height: 240px;
      border-radius: 0 0 5px 5px;
      border: 1px solid #cecece;
      border-top: none;
      overflow-y: auto;
      .searchedWrap {
        border-bottom: 2px solid #f7f7f7;
      }
      .searchedItem {
        border-top: 1px solid #f7f7f7;
        margin-top: 6px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px 20px 2px 20px;
        h4 {
          color: #40977f;
          font-weight: 600;
        }
      }
      .searchedItem:nth-child(0) {
        border: none;
      }
      .searchedItem.optionItem {
        border: none;
        padding: 4px 50px 4px 20px;
        h4 {
          max-width: 70%;
          font-size: 14px;
          line-height: 18px;
          word-break: break-all;
          color: #777777;
        }
        h4.price {
          font-weight: 400;
        }
      }
    }
  }

  /* label {
    display: flex;
    align-items: center;
    gap: 16px;
    color: #555555;
    font-size: 16px;
    line-height: 20px;
  } */
  input[type='checkbox'] {
    accent-color: #40977f;
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }

  input,
  textarea {
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #cecece;
    border-radius: 5px;
    color: #555555;
  }

  input::placeholder {
    color: #cecece;
  }
`;
